import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据粉丝id，获取客户信息
export function webGetExpansionByFansId(fansId,callback){
	request({
			method: 'post',
			url: 'AutoFriendMobileExpansion/getByFansId',
			data: {
			  fansId: fansId
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存或更新客户信息
export function webSaveExpansion(data,callback){
	request({
			method: 'post',
			url: 'AutoFriendMobileExpansion/save',
			data: data
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 粉丝与客户信息绑定
export function webExpansionBind(data,callback){
	request({
			method: 'post',
			url: 'AutoFriendMobileExpansion/bind',
			data: data
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}